import { OrgaIdent } from 'fobclient/lib/entity'

export default {
  route: 'orgaIdent',
  class: OrgaIdent,
  className: 'orgaIdent',
  entityName: 'de.ul.fob.domain.OrgaIdent',
  fields: [
    {
      label: 'OrgaIdent.form.typ',
      field: 'typ'
    },
    {
      label: 'OrgaIdent.form.wert',
      field: 'wert'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/OrgaIdent.js